<template>
  <div class="box database" :class="{ faded: disabled }">
    <div class="top">
      <bisgraf-checkbox
        class="large-checkbox"
        v-model="isSelected"
        @input="onSelectDatabase"
        :disabled="disabled"
      ></bisgraf-checkbox>
      <div class="body">
        <div class="title">
          <h4>{{ database.name }}</h4>
          <h5 v-if="database.name.toLowerCase() === 'morningstar' && $i18n.locale === 'en'">Included</h5>
          <h5 v-else-if="isItemFree">Free</h5>
          <h5 v-else>+{{ database[selectedInterval].formattedPrice }}</h5>
        </div>
        <p>
          {{ database.description }}
        </p>
        <div class="bottom" v-if="database.name === 'Bizzdo, Sweden'">
          <div class="contains-static-link">
            <a :href="$t('purchaseLicense.bizzdoReadMoreLink')" target="_blank">
              {{ $t("generic.readMore") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/variables.scss";

.faded {
  opacity: 0.5;
}

.database {
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
  padding: 20px 20px 10px 20px;
  display: flex;
  flex-direction: column;
  user-select: none;
  cursor: pointer;
  @media only screen and (max-width: $breakpoint-large) {
    width: 100%;
    margin: 0 auto 30px;
    max-width: 600px;
  }

  .top {
    display: flex;
    .body {
      width: 100%;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h4 {
          margin: 0;
          font-size: 18px;
        }
        h5 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
        }
      }
    }
    p {
      font-size: 15px;
      line-height: 1.5em;
      &:first-of-type {
        margin-top: 6px;
      }
    }
    .large-checkbox {
      margin: 0;
      width: 30px;
      flex-shrink: 0;
    }
  }

  .bottom {
    display: flex;
    div {
      text-align: left;
      font-size: 15px;
      flex: 1 1 50%;
    }
  }
}
</style>

<script>
import BisgrafCheckbox from "./BisgrafCheckbox.vue";
export default {
  name: "PurchaseLicenseDatabaseItem",

  props: {
    database: {
      type: Object,
      required: true
    },
    selectedInterval: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  components: { BisgrafCheckbox },

  data() {
    return {};
  },

  computed: {
    isItemFree() {
      return this.database[this.selectedInterval].price === 0;
    }
  },

  methods: {
    onSelectDatabase() {
      this.$emit("database-toggled");
    }
  }
};
</script>
